import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MenuIcon from "@material-ui/icons/Menu";
import Button from "./Button";
import BrandLogo from "./BrandLogo";
import ProfileDropdown from "./company/ProfileDropdown";
import { useAppBrandInfo } from "../hooks/useAppBrandInfo";
import { setFilterText, setFilterColor } from "../actions/filters";
import { openSidebar, closeSidebar } from "../actions/ui";
import { startLogout } from "../actions/auth";
import classes from "./Header.module.css";

function Header(props) {
  const { brandInfo } = useAppBrandInfo();
  const clearSearch = () => {
    props.setFilterText("");
    props.setFilterColor("");
  };
  const toggleSidebar = (event) => {
    event.stopPropagation();
    props.sidebarOpen ? props.closeSidebar() : props.openSidebar();
  };

  return <header className={classes.header}>
    <button type="button" className={classes.HamburgerMenu} aria-label="Toggle navigation"
      aria-expanded={props.sidebarOpen} onClick={toggleSidebar}><MenuIcon fontSize="inherit" /></button>
    <Link to="/" onClick={clearSearch} className={classes.brand} aria-label={`${brandInfo.app_name} ${brandInfo.product_name} home`}>
      <BrandLogo className={classes.logo} />
      <span className={classes.productName}>{brandInfo.product_name}</span>
    </Link>
    <div className={classes.Search}>
      <div className={classes.SearchButton}><Button tooltipTitle="Search"><SearchIcon /></Button></div>
      <input type="text" aria-label="Search notes" placeholder={"Search" + (props.color ? " within " + props.color : "")}
        value={props.text} onChange={(event) => props.setFilterText(event.target.value)} />
      <div className={classes.ClearButton}><Button tooltipTitle="Clear Search and Color Filter" onClick={clearSearch}><ClearIcon /></Button></div>
    </div>
    <ProfileDropdown onLogout={props.startLogout} />
  </header>;
}

const mapStateToProps = (state) => ({
  text: state.filters.filterText,
  color: state.filters.filterColor,
  sidebarOpen: state.ui.sidebarOpenMobile,
});

export default connect(mapStateToProps, {
  setFilterText, setFilterColor, openSidebar, closeSidebar, startLogout,
})(Header);
